import * as ruleManage from '../services/ruleManage';

export default {
  namespace: 'ruleManage',

  state: {
    getRuleManaList: null,
    addRuleManaList: null,
    editRuleManaList: null,
    deleteRuleManaList: null,
    uploadFile: null,
    exportFieldPackage: null,
  },

  effects: {
    *getRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(ruleManage.getRuleManaList, values);
      yield put({
        type: 'save',
        payload: {
          getRuleManaList: response,
        },
      });
      if (response) {
        if (callback && typeof callback === 'function') {
          return callback(response);
        }
      }
    },

    *addRuleManaList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(ruleManage.addRuleManaList, values);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      if (response.data) {
        yield put({
          type: 'save',
          payload: {
            addRuleManaList: response.data,
          },
        });
      }
    },

    *editRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManage.editRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          editRuleManaList: response,
        },
      });
    },
    *deleteRuleManaList({ payload: { values }, callback }, { call, put }) {
      const { data: response } = yield call(
        ruleManage.deleteRuleManaList,
        values,
      );
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          deleteRuleManaList: response,
        },
      });
    },
    // 上传
    *uploadFile({ payload: { values, id }, callback }, { call, put }) {
      const { data: response } = yield call(ruleManage.uploadFile, values, id);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          uploadFile: response,
        },
      });
    },
    // 导出
    *exportFieldPackage({ payload: { id }, callback }, { call, put }) {
      const { data: response } = yield call(ruleManage.exportFieldPackage, id);
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
      yield put({
        type: 'save',
        payload: {
          exportFieldPackage: response,
        },
      });
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
